import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { CUTOFF_TIMER_PRESET_ICON_NAMES, CUTOFF_TIMER_PRESET_ICON_URLS } from '../../defaults';
import {
  UploadIconDialogComponent,
  UploadIconDialogResult,
} from '@app/sharedModule/components/upload-icon-dialog/upload-icon-dialog.component';

@Component({
  selector: 'cutoff-timer-component-editor',
  templateUrl: './cutoff-timer-component-editor.component.html',
  styleUrls: ['./cutoff-timer-component-editor.component.scss'],
  standalone: false,
})
export class CutoffTimerComponentEditorComponent implements OnInit {
  @Input() componentForm: UntypedFormGroup;

  optionsForm: UntypedFormGroup;
  initialDisplayMessage: string;

  readonly cutoffTimerPosition = ShopPlugin.ProductPagePromise.CutoffTimerPosition;
  readonly presetIconUrls = CUTOFF_TIMER_PRESET_ICON_NAMES.map((name) => CUTOFF_TIMER_PRESET_ICON_URLS[name]);

  private destroyRef = inject(DestroyRef);

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.optionsForm = this.componentForm.get('options') as UntypedFormGroup;
    this.initialDisplayMessage = this.optionsForm?.get('displayMessage')?.value ?? '';
  }

  get isStandalone(): boolean {
    return this.optionsForm?.get('position')?.value === ShopPlugin.ProductPagePromise.CutoffTimerPosition.STANDALONE;
  }

  get iconUrlValue(): string | File {
    return this.optionsForm?.get('iconUrl')?.value ?? '';
  }

  get customIconUrlValue(): string | File {
    return this.optionsForm?.get('customIconUrl')?.value ?? '';
  }

  onDisplayMessageChange(html: string): void {
    this.optionsForm.get('displayMessage').setValue(html);
    this.optionsForm.markAsDirty();
  }

  onIconUrlChange(value: string | File): void {
    this.optionsForm.get('iconUrl').setValue(value);
    this.optionsForm.markAsDirty();
  }

  onUploadCustomIcon(): void {
    this.dialog
      .open<UploadIconDialogComponent, void, UploadIconDialogResult | null>(UploadIconDialogComponent, {
        width: '576px',
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (!result) return;
        this.optionsForm.get('customIconUrl').setValue(result.file);
        this.optionsForm.get('iconUrl').setValue(result.file);
        this.optionsForm.markAsDirty();
      });
  }

  onClearBackgroundColor(): void {
    this.optionsForm?.get('backgroundColor')?.setValue('');
    this.optionsForm?.markAsDirty();
  }

  onRemoveCustomIcon(): void {
    const customValue = this.optionsForm.get('customIconUrl')?.value;
    const iconValue = this.optionsForm.get('iconUrl')?.value;
    const wasSelected = !!customValue && iconValue === customValue;
    this.optionsForm.get('customIconUrl').setValue(null);
    if (wasSelected) {
      this.optionsForm.get('iconUrl').setValue('');
    }
    this.optionsForm.markAsDirty();
  }
}
